import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { Languages } from '../enums'

const REACT_APP_API_URL = process.env.REACT_APP_API_URL ?? ''
const REACT_APP_I18N_ENV = process.env.REACT_APP_I18N_ENV
const isProduction = REACT_APP_I18N_ENV === 'production' || /[./]invapps[.]com[/]?$/.test(REACT_APP_API_URL)
const suffix = isProduction ? 'prod' : 'dev'
// console.log({ process, env: process.env, REACT_APP_I18N_ENV })

const options = {
	backend: {
		// loadPath: `/locales/{{lng}}/{{ns}}.json`,
		loadPath: `/locales/{{lng}}/{{ns}}.{{lng}}.${suffix}.json`,
	},

	// allow keys to be phrases having `:`
	//nsSeparator: false,

	fallbackLng: [Languages.default], // fallback language is english.

	detection: {
		checkWhitelist: true, // options for language detection
	},

	//debug: !isProduction,

	whitelist: Languages.values,

	interpolation: {
		escapeValue: false, // no need for react. it escapes by default
	},

	react: {
		// useSuspense: false //   <---- this will do the magic
	}
}

i18n
	.use(initReactI18next) // pass the i18n instance to react-i18next.
	.use(Backend) // load translations using http (default public/assets/locals/en/translations)
	.use(LanguageDetector) // detect user language
	.init(options, (error) => {
		if (!isProduction) {
			if (error) {
				console.error('i18n', { error })
			} else {
				console.log('i18n', { options })
			}
		}
	})

export default i18n
